import { createPublicClient } from '../../../../app/infrastructure/http/apiClient';
import type { ConfirmValidationPayload } from '../../application/types';

export async function confirmValidation(payload: ConfirmValidationPayload) {
  return createPublicClient().post('/validations/confirm', payload);
}
